import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, Globe, MessageCircle } from "lucide-react";
import { BRAND, wa } from "@/lib/brand";

const col = "flex flex-col gap-2";
const link = "text-[13px] text-white/70 hover:text-[#D4AF37] transition-colors";

const Footer = () => (
  <footer className="bg-[#002B18] text-[#F4F4ED] mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
      <div className="col-span-2 md:col-span-1">
        <div className="flex items-center gap-3">
          <img src={BRAND.logo} alt="GN Agro Traders" className="h-14 w-14 rounded-full bg-white/5 p-1" />
          <div>
            <div className="font-display text-xl text-white">GN Agro Traders</div>
            <div className="text-[10px] font-eyebrow text-[#D4AF37]">Pure Grains · Global Standards</div>
          </div>
        </div>
        <p className="mt-4 text-[13px] text-white/70 leading-relaxed">
          {BRAND.legal}. A professional Indian agro trading and export supply partner connecting Indian agricultural excellence to global buyers.
        </p>
      </div>

      <div className={col}>
        <div className="font-eyebrow text-[11px] text-[#D4AF37]">Quick Links</div>
        <Link to="/" className={link}>Home</Link>
        <Link to="/about" className={link}>About</Link>
        <Link to="/products" className={link}>Products</Link>
        <Link to="/quality" className={link}>Quality</Link>
        <Link to="/packaging" className={link}>Packaging</Link>
        <Link to="/logistics" className={link}>Logistics</Link>
        <Link to="/insights" className={link}>Insights</Link>
        <Link to="/contact" className={link}>Contact</Link>
      </div>

      <div className={col}>
        <div className="font-eyebrow text-[11px] text-[#D4AF37]">Product Categories</div>
        <Link to="/products/basmati-rice" className={link}>Basmati Rice</Link>
        <Link to="/products/non-basmati-rice" className={link}>Non-Basmati Rice</Link>
        <Link to="/products/pulses-dals" className={link}>Pulses & Dals</Link>
        <Link to="/products/wheat" className={link}>Wheat</Link>
        <Link to="/products/flours" className={link}>Flours</Link>
        <Link to="/products/other" className={link}>Agro Commodities</Link>
      </div>

      <div className={col}>
        <div className="font-eyebrow text-[11px] text-[#D4AF37]">Contact</div>
        <a href={`tel:${BRAND.phoneTel}`} className={`${link} flex items-center gap-2`}><Phone className="h-3.5 w-3.5" />{BRAND.phone} (Primary)</a>
        <a href={`tel:${BRAND.phone2Tel}`} className={`${link} flex items-center gap-2`}><Phone className="h-3.5 w-3.5" />{BRAND.phone2}</a>
        <a href={`mailto:${BRAND.email}`} className={`${link} flex items-center gap-2`}><Mail className="h-3.5 w-3.5" />{BRAND.email}</a>
        <a href={BRAND.website} target="_blank" rel="noopener noreferrer" className={`${link} flex items-center gap-2`}><Globe className="h-3.5 w-3.5" />gnagrotraders.com</a>
        <a href={wa()} target="_blank" rel="noopener noreferrer" className={`${link} flex items-center gap-2`}><MessageCircle className="h-3.5 w-3.5" />WhatsApp us</a>
        <Link to="/request-quote" className="mt-2 inline-block rounded-full bg-[#D4AF37] text-[#002B18] px-4 py-2 text-[11px] font-semibold uppercase tracking-widest">Request a Quote</Link>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row gap-2 md:gap-6 items-center justify-between">
        <div className="text-[11px] text-white/50">© {new Date().getFullYear()} {BRAND.legal}. All rights reserved.</div>
        <div className="text-[11px] flex flex-wrap gap-4 text-white/60">
          <span className="hover:text-white cursor-default">Privacy Policy</span>
          <span className="hover:text-white cursor-default">Terms & Conditions</span>
          <span className="hover:text-white cursor-default">Shipping / Delivery</span>
          <span className="hover:text-white cursor-default">Disclaimer</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
